import React from 'react';
import { BUTTON_SIZE } from '@/config/ui/button';
import { POPUP_HEIGHT } from '@/config/ui/popup';
import { ForwardButton } from '../../component/atom/Button';
import ChoiceChip from '../../component/atom/ChoiceChip';
import Popup from '../../component/composite/Popup';
import { S } from '../util/style';
import { s } from './style';
import { POPUP_TYPE } from '../../config/popup';
const renderPopupBody = ({ partTimeTimeSlotOptionList, handleChoiceChipClick, getIsChoiceChipSelected, }) => (<S.PopupBody>
    <S.PopupBodyLayoutGrid>
      {partTimeTimeSlotOptionList.map((option) => (<ChoiceChip key={option.expectedStartTime} isSelected={getIsChoiceChipSelected({
            optionExpectedStartTime: option.expectedStartTime,
        })} content={<s.LayoutChipContent>
              {option.parsedExpectedStartTime}
              {option.isCrossDay ? <span>{option.parsedExpectedEndTime}</span> : null}
            </s.LayoutChipContent>} onChipClick={() => handleChoiceChipClick({ optionExpectedStartTime: option.expectedStartTime })}/>))}
    </S.PopupBodyLayoutGrid>
  </S.PopupBody>);
const renderPopupFooter = ({ closePopup, isForwardButtonAvailable, }) => (<S.PopupFooterWithoutNotes>
    <ForwardButton onButtonClick={closePopup} isAvailable={isForwardButtonAvailable} size={BUTTON_SIZE.MEDIUM}>
      確認
    </ForwardButton>
  </S.PopupFooterWithoutNotes>);
export default function View({ 
// data
popupType, partTimeTimeSlotOptionList, isForwardButtonAvailable, 
// func
closePopup, handleChoiceChipClick, getIsChoiceChipSelected, }) {
    return (<Popup height={POPUP_HEIGHT.LARGE} title='服務日期' isSlideIn={popupType === POPUP_TYPE.PART_TIME_TIME_SLOT_LIST} closePopup={closePopup} popupBody={renderPopupBody({
            partTimeTimeSlotOptionList,
            handleChoiceChipClick,
            getIsChoiceChipSelected,
        })} popupFooter={renderPopupFooter({ closePopup, isForwardButtonAvailable })} isRenderCloseBtn/>);
}
